<form class="w-[450px] font-inter" [formGroup]="fg">
  <div class="flex flex-col justify-between">
    <aux-input
      class="tabular-nums"
      formControlName="po_number"
      label="PO #"
      placeholder="PO #"
      [showRequiredAsterisk]="true"
      [validators]="poNumberValidators"
      [auxTooltip]="disabledTooltip()"
    />

    <div class="mt-4">
      <label for="vendors" class="mb-1 block text-xs">
        Vendor Contract
        <span class="font-bold text-aux-error">*</span>
      </label>
      <ng-select
        placeholder="Select"
        id="vendors"
        class="select"
        label="Vendor Contract"
        auxFormError
        [formControl]="selectedVendor"
        [searchable]="true"
        [clearable]="false"
        [required]="true"
        [auxTooltip]="disabledTooltip()"
      >
        @for (vendor of vendorQuery.allVendors$ | async; track vendor) {
          <ng-option [value]="vendor.id">
            <span [title]="vendor.name">{{ vendor.name }}</span>
          </ng-option>
        }
      </ng-select>
    </div>
  </div>

  <div class="mt-4">
    <label for="poStatus" class="mb-1 block text-xs">
      Auxilius PO Status
      <span class="font-bold text-aux-error">*</span>
    </label>
    <ng-select
      placeholder="Select"
      id="poStatus"
      [items]="poStatusOptions"
      class="select"
      label="Auxilius PO Status"
      auxFormError
      formControlName="po_status"
      bindValue="value"
      [searchable]="false"
      [clearable]="false"
      [required]="true"
    />
  </div>

  @if (poId) {
    <div class="flex flex-col">
      <div class="mb-1 mt-4 text-xs">Supporting documents</div>
      <aux-file-manager
        #fileManager
        class="h-48"
        [eager]="false"
        [pathFn]="pathFn"
        [fetchFilesOnInit]="true"
        [document_entity_id]="poId"
        (onFilesAdded)="setChanges()"
        (filesRemoved)="removeFile($event)"
      />
    </div>

    <div class="mt-4 max-h-60 overflow-auto">
      <aux-file-viewer
        [fileManager]="fileManager"
        [disableFirstFileMargin]="true"
        [onlyShowUploaded]="false"
        [type]="'edc'"
        [showUserAndDate]="true"
      />
    </div>
  } @else {
    <div class="flex flex-col">
      <div class="mb-1 mt-4 text-xs">Supporting documents</div>
      <aux-file-manager
        #fileManager
        class="h-48"
        [eager]="false"
        [pathFn]="pathFn"
        (onFilesAdded)="setChanges()"
        (filesRemoved)="setChanges()"
      />
    </div>

    <div class="mt-4 max-h-60 overflow-auto">
      <aux-file-viewer
        [fileManager]="fileManager"
        [disableFirstFileMargin]="true"
        [onlyShowUploaded]="false"
        [type]="'edc'"
        [showUserAndDate]="true"
      />
    </div>
  }

  <aux-input
    placeholder="Notes..."
    label="Notes"
    [textArea]="true"
    [rows]="5"
    resize="none"
    class="textarea-input mt-4"
    [maxlength]="1000"
    formControlName="description"
  />
</form>
